function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(20409 -1914)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  transform: "translate(-20409 1914)",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-86.958 -320.398)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-20316.984 2241.87)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-4493.871,4578.2q-5.348,0-10.7,0c-.829,0-1.058-.251-1.059-1.1q0-4.045,0-8.091c0-.664,0-.665.649-.665h9.138l9.185-.01c.485,0,.62.142.616.622,0,.3,0,.593,0,.889h2.166q0-3.7,0-7.4a2.919,2.919,0,0,0-2.949-2.971q-9-.015-17.993,0a2.906,2.906,0,0,0-2.967,2.95q-.017,7.474,0,14.946a2.924,2.924,0,0,0,2.994,2.972q4.474,0,8.95,0h1.976Zm5.531-15.8a1.473,1.473,0,0,1,1.548,1.5,1.522,1.522,0,0,1-1.521,1.554,1.5,1.5,0,0,1-1.561-1.55A1.44,1.44,0,0,1-4488.34,4562.4Zm-4.458.008a1.387,1.387,0,0,1,1.475,1.534,1.446,1.446,0,0,1-1.535,1.505,1.48,1.48,0,0,1-1.509-1.591A1.409,1.409,0,0,1-4492.8,4562.406Zm-4.528-.007a1.449,1.449,0,0,1,1.529,1.506,1.516,1.516,0,0,1-1.524,1.544,1.489,1.489,0,0,1-1.537-1.561A1.411,1.411,0,0,1-4497.327,4562.4Z",
  transform: "translate(4507.798 -4559.467)",
  fill: "currentColor",
  fillRule: "evenodd"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-20301.744 2253.1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-4342.411,4689.523h-3.63a1.561,1.561,0,0,1-1.7-1.706c0-1.161.013-2.323,0-3.484a1.524,1.524,0,0,1,1.652-1.628c.207.025.256-.061.257-.259.007-.709,0-1.419.056-2.125a3.323,3.323,0,0,1,2.875-2.9,3.331,3.331,0,0,1,3.461,1.7,3.62,3.62,0,0,1,.438,1.836c.008.483.015.968,0,1.452-.008.234.063.309.3.293a1.362,1.362,0,0,1,1.381.744,1.873,1.873,0,0,1,.214.828c.022,1.209.012,2.42.009,3.629a1.539,1.539,0,0,1-1.611,1.615C-4339.943,4689.526-4341.177,4689.523-4342.411,4689.523Zm-.014-6.81c.573,0,1.145,0,1.717,0,.122,0,.221,0,.218-.17-.01-.636.015-1.274-.017-1.909a1.855,1.855,0,0,0-1.886-1.763,1.845,1.845,0,0,0-1.924,1.741c-.038.635-.013,1.272-.025,1.909,0,.174.083.194.226.193C-4343.552,4682.71-4342.989,4682.713-4342.425,4682.713Zm.786,3.388h-.008a4.851,4.851,0,0,0,0-.506.75.75,0,0,0-.743-.66.722.722,0,0,0-.771.614,5.893,5.893,0,0,0-.013,1.058.714.714,0,0,0,.812.648.727.727,0,0,0,.725-.721C-4341.634,4686.39-4341.639,4686.245-4341.639,4686.1Z",
  transform: "translate(4347.739 -4677.397)",
  fill: "currentColor",
  fillRule: "evenodd"
}))));

function SvgIconSystemLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSystemLogin);
export default __webpack_public_path__ + "static/media/icon-system-login.7f7cb8d9.svg";
export { ForwardRef as ReactComponent };